'use client'

// THEME COMPLIANCE: All UI implementations must support both dark and light themes.

import * as React from 'react'
import { useRouter } from 'next/navigation'
import { Users, Play, TrendingUp } from 'lucide-react'
import { cn } from '@/lib/utils'

const STEPS = [
  {
    id: 'build',
    icon: Users,
    title: 'BUILD & SCOUT',
    description: 'Draft your squad with real roles and form using a limited budget.'
  },
  {
    id: 'subs',
    icon: Play,
    title: 'LIVE SUBSTITUTIONS',
    description: 'Time subs, captaincy, and transfer moves as matches unfold in real time.'
  },
  {
    id: 'win',
    icon: TrendingUp,
    title: 'CLIMB & WIN',
    description: 'Collect as many points as possible and win cash prizes.'
  }
]

export default function StepsToSuccessSection() {
  const router = useRouter()

  return (
    <section className="relative py-12 md:py-24 text-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-12">
          <h2
            className={cn(
              'text-[14.4px] sm:text-xl md:text-5xl',
              'font-bold leading-tight font-montserrat tracking-[0.3em] uppercase'
            )}
          >
            HOW IT WORKS
          </h2>
        </div>

        <div className="flex flex-row gap-[11px] sm:gap-4 md:gap-8 items-center justify-center">
          {STEPS.map(({ id, icon: Icon, title, description }) => (
            <article
              key={id}
              className="relative w-[95px] sm:w-[140px] md:w-full h-[88px] sm:h-[130px] md:max-w-[349px] md:h-[324px] rounded-[16px] bg-neu-surface flex flex-col items-center justify-center text-center px-2 sm:px-4 md:px-[54px] py-3 sm:py-5 md:py-[63px] gap-2 md:gap-5"
              style={{
                boxShadow:
                  '-10px -10px 30px var(--neu-shadow-light), 10px 10px 30px var(--neu-shadow-dark)'
              }}
            >
              <div className="w-6 h-6 sm:w-9 sm:h-9 md:w-16 md:h-16 rounded-full border-[3px] md:border-[5px] border-white/80 flex items-center justify-center">
                <Icon
                  className="w-3 h-3 sm:w-5 sm:h-5 md:w-8 md:h-8 text-white"
                  strokeWidth={2.3}
                />
              </div>
              <div className="space-y-1 md:space-y-3">
                <h3 className="text-[7px] sm:text-[10px] md:text-xl font-montserrat font-bold uppercase tracking-[0.3em]">
                  {title}
                </h3>
                <p className="text-[5px] sm:text-[8px] md:text-sm leading-relaxed text-white/85">
                  {description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="flex justify-center mt-8 md:mt-12">
          <button
            className="relative px-6 sm:px-8 md:px-10 py-3 sm:py-3.5 md:py-4 rounded-[18px] bg-gradient-to-r from-neu-brand-from to-neu-brand-to text-[9px] sm:text-xs md:text-sm font-montserrat font-bold tracking-[0.3em] uppercase text-white shadow-[0px_20px_40px_rgba(5,84,135,0.5)] focus:outline-none focus:ring-2 focus:ring-sky-300/60"
            onClick={() => router.push('/login')}
          >
            CREATE YOUR DREAM TEAM NOW
          </button>
        </div>
      </div>
    </section>
  )
}
